import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import type { InnogyComponentRendering } from '@core/jss-models';
import { ModalBodyDirective, ModalComponent } from '@legacy/common-ui-shared';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';

@Component({
  selector: 'wl-vertical-offer-modal-placeholder',
  templateUrl: './vertical-offer-modal-placeholder.component.html',
  styleUrls: [],
  standalone: true,
  imports: [ModalComponent, ModalBodyDirective, JssModule, CommonModule],
})
export class VerticalOfferModalPlaceholderComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public rendering: InnogyComponentRendering | undefined;

  constructor(private readonly modal: NgbActiveModal) {}

  dismissModal() {
    this.modal.dismiss('dismiss');
  }
}
